var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumaIntelligence40X40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "white",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "url(#paint0_linear_816_3212)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5127 26.7588L28.9375 27.0986L30.001 27.29V27.6514H25.6221V27.29L26.7275 27.0986L27.1943 26.7588V18.0859L25.6855 17.8096V17.4697L28.2578 16.96H28.5127V26.7588ZM15.2715 12.707L13.8262 12.8984L13.2305 13.2393V19.3818H21.0957V13.2393L20.501 12.8984L19.0547 12.707V12.3457H24.3262V12.707L23.0938 12.8984L22.6045 13.2393V26.7578L23.0938 27.0977L24.3262 27.2891V27.6504H19.0547V27.2891L20.501 27.0977L21.0957 26.7578V20.041H13.2305V26.7578L13.8262 27.0977L15.2715 27.2891V27.6504H10V27.2891L11.2324 27.0977L11.7217 26.7578V13.2393L11.2324 12.8984L10 12.707V12.3457H15.2715V12.707ZM27.4922 12.4961C28.151 12.4961 28.6824 13.0482 28.6826 13.707C28.6826 14.366 28.1511 14.8975 27.4922 14.8975C26.812 14.8974 26.2803 14.3659 26.2803 13.707C26.2805 13.0483 26.8122 12.4961 27.4922 12.4961Z",
    fill: "#424347"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_816_3212",
    x1: 34.0875,
    y1: 47.7509,
    x2: -11.4652,
    y2: 14.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0387,
    stopColor: "#729DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#78CCD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6661,
    stopColor: "#FFAAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9588,
    stopColor: "#FFB64A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumaIntelligence40X40);
export default __webpack_public_path__ + "static/media/Huma Intelligence 40x40.dd3a2cab53ab84e0013057d9b6a17a15.svg";
export { ForwardRef as ReactComponent };